let urnwallFromList = false;

$(function() {
    //Urnwall modal
    const urnwallModal = $('.js-urnwall-modal');
    const urnwallSlider = $('.js-urn-slider');
    const marker = $('.js-mark-selection');
    const routePlanner = $('.js-get-route');

    //Load the data for the selected grave or urnwall
    $.loadSelectedGrave = async function loadSelectedGrave(id, graveId) {
        $.ajax({
            url: `${window.api}/graves/${graveId}`,
            type: 'GET',
            data: graveId,
            headers: {
                Authorization: 'Bearer ' + window.iFrameToken,
            },
            success: function(response) {
                window.graveId = response.id;
                let graveName;
                const { geom, photos, parcel = '', deads, fancyName } = response;
                const row = response.row === null ? '' : '/' + response.row;
                const pos = response.pos === null ? '' : '-' + response.pos;

                const selectedElement = response;

                if (!selectedElement.routes) {
                    routePlanner.addClass('grave-action-disabled');
                }

                if (fancyName) {
                    graveName = fancyName;
                } else {
                    graveName = parcel + row + pos;
                }

                const urns = response.urns ? response.urns : null;

                if (urns !== null && urns.length > 0) {
                    window.urnX = Math.max(...urns.map(o => o.x))
                    window.urnY = Math.max(...urns.map(o => o.y))
                }
                window.graveyard = response.graveyardId;
                urnwallFromList = urns.length > 0;
                window.widget.addSelection('select', {
                    id: graveId,
                    geom: geom,
                    layerName: 'Grave',
                });
                $.loadGraveyard();

                if (urns.length) {
                    const tabletView = window.innerWidth >= 672 && window.innerWidth <= 1199;
                    let colsToGet = tabletView ? 2 : getUrnwallCollsByWindowWidth();

                    urnwallModal.removeClass('visible-print');
                    createUrnwallSlider(urns, colsToGet, $('.js-urn-slider'));
                    if (tabletView && !urnwallModal.hasClass('has-selected')) {
                        urnwallModal.addClass('has-selected');
                    }

                    const urnToGet = urns.find(urn => urn.deads.find(d => d.id === id));
                    if (urnToGet) {
                        if (tabletView && !urnwallModal.hasClass('has-selected')) {
                            urnwallModal.addClass('has-selected');

                            createUrnwallSlider(urns, 2, $('.js-urn-slider'));
                        }
                        $.loadSelectedUrn(urnToGet.id);

                        goToUrnwallActiveSlide(urnwallSlider);
                    }
                } else {
                    $('.about-title').text(graveName);
                }

                if (!urns.length) {
                    deads.sort(function(a, b) {
                        const textA = a.name.toUpperCase();
                        const textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    const output = createDeceasedList(deads);

                    if (selectedElement && selectedElement.description) {
                        const description = `<div class="grave-description time">
                        <p>${selectedElement.description}</p></div>`;
                        $('.js-output-card').html([description, ...output].join(''));
                    } else {
                        $('.js-output-card').html(output.join(''));
                    }
                }

                $('.js-urnwall-position').text(graveName);
                $('.swiper-title').text('Sírazonosító: ' + graveName);

                if (photos && photos.length !== 0) {
                    createThumbnailAndSlider(
                        photos,
                        $('.js-count-image'),
                        $('.js-modal-slider'),
                        $('.js-open-gallery')
                    );
                } else if (urns.length === 0) {
                    // no photo for the grave, set it to 0
                    $('.js-count-image').text(0);
                    // clear the background image
                    $('.about-box .img-container').css('background-image', '');
                }

                setFeedbackButtonStatus(
                    urns,
                    deads,
                    $('.js-urnwall-table'),
                    $('#about-box-footer--button'),
                    $('#about-box-footer--cancel')
                );

                $('.ol-zoom-in, .ol-zoom-out, .ol-zoom-extent button').css('right', '24px');
                $('.about-box').addClass('about-box-visible');
                $('.information-tab').addClass('information-tab-visible');

                const parentDiv = $('.about-box-body');
                const innerListItem = $(`.search-bar-results-block[data-id="${id}"]`);
                parentDiv.animate(
                    {
                        scrollTop:
                            parentDiv.scrollTop() -
                            parentDiv.offset().top +
                            innerListItem.offset().top,
                    },
                    1500
                );
            },
        });
    };

    $(document).on('click', '.search-bar-results-block .js-zoom-to', async function() {
        $('.search-bar').removeClass('search-bar-active');
        const id = $(this).data('id');
        window.graveId = $(this).data('graveid');
        $('.js-load-one-urnwall-data')
            .filter(`[data-id='${id}']`)
            .addClass('urn--active');
        await $.loadSelectedGrave(id, window.graveId);
        if (id === window.markedGraveId) {
            marker.attr('src', 'assets/img/icons/icon-location-marked.svg');
        } else {
            marker.attr('src', 'assets/img/icons/icon-location.svg');
        }
        if (id === window.routedGraveId) {
            routePlanner.attr('src', 'assets/img/icons/icon-route-active.svg');
        } else {
            routePlanner.attr('src', 'assets/img/icons/icon-route.svg');
        }
    });

    $.closeComponents = function closeComponents() {
        $('.about-box').removeClass('about-box-visible');
        $('.information-tab').removeClass('information-tab-visible');
        $('.hidden-block').removeClass('hidden-block-active');
        $('.js-close-view-nav').addClass('visible-print');
        $('.js-open-view-nav').removeClass('visible-print');
        $('.legend').removeClass('legend-active');
        $('.legend').removeClass('active-top');
    };

    //Close components
    $('.ol-zoom-extent button').on('click', $.closeComponents());

    $(document).on('click', '.js-arrow-back, .logo', function() {
        window.widget.zoomTo();
        $.closeComponents();
    });
});
